<template>

    <div>

        <div class="py-2 border-bottom">
            <div class="row">
                <div class="col-sm-4">
                    <div :style="indent">
                        {{ supplierCategory.name }}
                    </div>
                </div>
                <div class="col-sm-1">
                    <span class="text-black-50">
                        {{ supplierCategory.uid || '-' }}
                    </span>
                </div>
                <div class="col-sm-1">
                    <inertia-link :href="route('admin.products.index', {supplier_category_id: supplierCategory.id})"
                                  v-if="supplierCategory.number_products > 0">
                        {{ supplierCategory.number_products }}
                    </inertia-link>
                    <div class="text-black-50" v-else>
                        -
                    </div>
                </div>
                <div class="col-sm-6">

                    <div v-if="currentSupplierCategory.id != supplierCategory.id">

                        <div class="row">
                            <div class="col">
                                <template v-if="supplierCategory.categories.length">
                                    <span class="d-block" v-for="category in supplierCategory.categories">
                                        <b>
                                            {{ category.name }}
                                        </b>
                                        <span v-if="category.parent" class="text-muted">
                                            ({{ category.parent.name }})
                                        </span>
                                    </span>
                                </template>
                                <template v-else>
                                    -
                                </template>
                            </div>
                            <div class="col-auto">
                                <inertia-link :href="route('admin.suppliers.categories.index', {supplier, supplier_category_id: supplierCategory.id})"
                                              class="btn btn-sm btn-outline-dark"
                                              preserve-scroll
                                              >
                                    {{ __('Edit') }}
                                </inertia-link>
                            </div>
                        </div>

                    </div>
                    <div v-else>
                        <form @submit.prevent="form.post(route('admin.suppliers.categories.store', supplier), {preserveScroll: true})">

                                <multi-select-input
                                    v-model="form.mapped_categories" 
                                    value-consists-of="ALL"
                                    :flat="true"
                                    sort-value-by="INDEX"
                                    :multiple="true" 
                                    :options="categoryTreeOptions" 
                                    :default-expand-level="1"
                                    :placeholder="__('Search')"
                                    :error="form.errors.mapped_categories"
                                    />

                            <!--                       @todo     <div class="mb-2">
                                                            <radio-input label="Produktrelationen nicht ändern" value="keep" v-model="form.sync_products" />
                                                            <radio-input label="Produktrelationen inkrementell synchronisieren (ergänzt neue Relationen bei allen Produkten, ohne vorhandene zu löschen)" value="increment" v-model="form.sync_products" />
                                                            <radio-input label="Produktrelationen neu synchronisieren (ersetzt alle Relationen bei allen Produkten und löscht somit vorhandene Relationen)" value="replace" v-model="form.sync_products" />
                                                        </div>-->

                            <div class="">
                                <button type="submit" class="btn btn-primary">
                                    {{ __('Submit') }}
                                </button>
                                <button type="button" class="btn btn-outline-dark" @click="cancel">
                                    {{ __('Cancel') }}
                                </button>
                            </div>
                        </form>

                    </div>

                </div>
            </div>
        </div>

        <category-nodes v-for="childSupplierCategory in supplierCategory.children" 
                        :key="childSupplierCategory.id" 
                        :depth="depth + 1"
                        :supplier="supplier"
                        :supplier-category="childSupplierCategory"
                        :current-supplier-category="currentSupplierCategory"
                        :supplier-categories-flat="supplierCategoriesFlat"
                        :category-tree="categoryTree" />

    </div>

</template>


<script>

    import RadioInput from '@/shared/Inputs/RadioInput';
    import SubmitButton from '@/shared/Inputs/SubmitButton';
        import MultiSelectInput from '@/shared/Inputs/MultiSelectInput';


    export default {
        name: 'category-nodes',
        props: [
            'depth',
            'filters',
            'supplier',
            'categoryTree',
            'supplierCategory',
            'supplierCategoriesFlat',
            'currentSupplierCategory',
        ],
        components: {
            MultiSelectInput,
            RadioInput,
            SubmitButton,
        },
        data() {
            return {
                categoryTreeOptions: this.categoryTree,
                form: this.$inertia.form({
                    sync_products: 'keep',
                    supplier_category_id: this.currentSupplierCategory.id || null,
                    mapped_categories: this.supplierCategoriesFlat[this.currentSupplierCategory.id] || [],
                })
            }
        },
        watch: {
        },
        methods: {
            cancel() {
                this.$inertia.get(this.route('admin.suppliers.categories.index', this.supplier), {}, {preserveScroll: true});
            }
        },
        computed: {
            indent() {
                return {'padding-left': `${this.depth * 20}px`}
            }
        }
    }
</script>